import * as R from 'ramda';
import TableTabs from '../../../components/ListV2/components/tabs/TableTabs';
import { useUserHasOfflineDatabase } from '../../offline/database/offlineDatabase/hooks/useUserHasOfflineDatabase';
import { useTranslation } from '../../translation/TranslationContext';
import { useAbility } from '../../users/AbilityContext';
import { useGetOrderTotals } from '../hooks/useOrderTotals/order-totals.queries';
import getOrderListTabs, { OrderListTabName, OrderTab } from './orderListTabs';
import { combineTotals } from './utils/orderCombineTotals.utils';

interface OrderTableTabsProps {
  selectedTab: OrderListTabName;
  onChangeTab: (tab: OrderTab) => void;
}

const OrderTableTabs = ({ onChangeTab, selectedTab }: OrderTableTabsProps) => {
  const userHasOfflineDatabase = useUserHasOfflineDatabase();
  const { locale } = useTranslation();

  const { data, isLoading } = useGetOrderTotals();
  const { data: offlineData } = useGetOrderTotals({
    isOfflineMode: true,
    enabled: userHasOfflineDatabase,
  });

  const dataWithOffline = combineTotals(data, offlineData);
  const ability = useAbility();

  const orderListTabs = getOrderListTabs(ability);

  const tabs: OrderTab[] = R.isNil(dataWithOffline)
    ? orderListTabs
    : orderListTabs?.map((orderTab) => {
        const filteredData =
          orderTab.name === OrderListTabName.ALL
            ? dataWithOffline
            : dataWithOffline?.filter((item) => orderTab.status?.includes(item.orderStatus));

        const sum = R.sum(filteredData?.map((item) => item.totalOrders) ?? []);

        return {
          ...orderTab,
          subTitle: sum.toLocaleString(locale),
        };
      });

  return (
    <TableTabs<OrderTab>
      selected={selectedTab}
      onClick={onChangeTab}
      tabs={tabs}
      isLoading={isLoading}
    />
  );
};

export default OrderTableTabs;
